import { getCurrentEvent } from "core-integration/src/store/events/reducers";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";

const StatusBar = styled.div<IStatusBar>`
  padding: ${({ theme }) => `${theme.space[2]} ${theme.space[2]} 1.4rem`};
  border-radius: 0;
  background-color: ${(props) =>
    props.isFinished
      ? props.theme.colors.accentRed
      : props.theme.colors.success};
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: ${({ theme }) => theme.fontSizes[6]};
  font-weight: normal;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    border-radius: ${({ theme }) => theme.radii[1]};
  }
`;
interface IStatusBar {
  isFinished: boolean;
}

const EventStatusBar: React.FC = () => {
  const { t } = useTranslation();
  const now = useSelector(getCurrentEvent);
  if (!now) {
    return null;
  }
  const eventStatus = now.finished
    ? t("statusBar.complete", "complete")
    : t("statusBar.live", "live");

  return (
    <StatusBar isFinished={now.finished}>
      {t("statusBar.eventStatus", "Round is {{ isFinished }}", {
        isFinished: eventStatus,
      })}
    </StatusBar>
  );
};

export default EventStatusBar;
